const BASE_URL = 'https://api.cleany.qa/api/v1/admin/';

export default BASE_URL;
